import { Switch } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/20/solid";
import { StarIcon } from "@heroicons/react/24/solid";

interface ToggleProps {
  labelElement?: React.ReactNode;
  value: boolean;
  onChange: any;
  comp?: "checkbox" | "switch";
  checkBoxSize?: string;
  height?: string;
  width?: string;
  className?: string;
  disabled?: boolean;
  containerClass?: string;
  iconClassName?: string;
  isRequired?: boolean;
  onCheckRingColor?: string;
}

export default function Toggle({
  labelElement,
  value,
  onChange,
  comp = "switch",
  checkBoxSize,
  height,
  width,
  className,
  disabled,
  containerClass,
  iconClassName,
  isRequired = false,
  onCheckRingColor,
}: ToggleProps) {
  if (String(comp).toLowerCase() == "checkbox") {
    return (
      <div className="flex items-center gap-2">
        <div className={`flex items-center ${containerClass}`}>
          <Switch
            checked={value}
            onChange={onChange}
            disabled={disabled}
            className={`flex items-center justify-center rounded  ring-2  ${
              value
                ? `bg-primary ring-primary ${onCheckRingColor}`
                : "bg-transparent ring-gray"
            } ${className}`}
            style={{
              height: `${height || checkBoxSize}rem`,
              width: `${width || checkBoxSize}rem`,
            }}
          >
            {value ? (
              <CheckIcon
                className={`text-primary rounded  ${iconClassName} `}
              />
            ) : (
              <></>
            )}
          </Switch>
          {labelElement}
        </div>
      </div>
    );
  }
  return (
    <div className={`flex items-center gap-2 ${containerClass}`}>
      <>
        {labelElement}
        {isRequired && (
          <StarIcon className="size-2 text-error -translate-y-1" />
        )}
      </>
      <Switch
        checked={value}
        onChange={onChange}
        disabled={disabled}
        className={`${value ? "bg-primary" : "bg-gray"}
          relative inline-flex h-[20px]  w-[40px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus:shadow-md focus:shadow-lightGray`}
      >
        <span
          aria-hidden="true"
          className={`${value ? "translate-x-5" : "translate-x-0"}
            pointer-events-none inline-block h-[16px] w-[16px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
    </div>
  );
}
